import React from 'react';

const Border = () => {
    return (
        <div>
            <div style={{height:"1px", width:"99%",margin:"auto"}} className='bg-info my-5'></div>
        </div>
    );
};

export default Border;